import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VueApexCharts from "vue3-apexcharts";
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura';

const app = createApp(App);
app.use(VueApexCharts);

app.use(PrimeVue,  {
    // Default theme configuration
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: 'system',
            cssLayer: false
        }
    }
 })

app.use(router).use(store).mount('#app')
